import { createStore } from 'vuex';

export default createStore({
    state: {
        selectedColorIndex: 0,
        colors: [
            { color: "var(--yellow)", favicon: "favicon-yellow.ico", colorName: "yellow" },
            { color: "var(--green)", favicon: "favicon-green.ico", colorName: "green" },
            { color: "var(--orange)", favicon: "favicon-orange.ico", colorName: "orange" },
            { color: "var(--red)", favicon: "favicon-red.ico", colorName: "red" },
            { color: "var(--violet)", favicon: "favicon-violet.ico", colorName: "violet" },
            { color: "var(--blue)", favicon: "favicon-blue.ico", colorName: "blue" },
            { color: "var(--pink)", favicon: "favicon-pink.ico", colorName: "pink" },
            { color: "var(--cian)", favicon: "favicon-cian.ico", colorName: "cian" },
            { color: "var(--magenta)", favicon: "favicon-magenta.ico", colorName: "magenta" },
        ],
    },
    getters: {
        currentColorName: (state) => state.colors[state.selectedColorIndex].colorName,
        currentFavicon: (state) => state.colors[state.selectedColorIndex].favicon,
    },
    mutations: {
        changeColor(state) {
            state.selectedColorIndex = (state.selectedColorIndex + 1) % state.colors.length;
        },
        updateFavicon(state) {
            const favicon = state.colors[state.selectedColorIndex].favicon;
            let link = document.querySelector("link[rel='icon']");
            if (!link) {
                link = document.createElement("link");
                link.rel = "icon";
                document.head.appendChild(link);
            }
            link.href = `/${favicon}`;
        },
    },
    actions: {
        changeColorAndFavicon({ commit }) {
            commit("changeColor");
            commit("updateFavicon");
        },
    },
});